import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static classes = ["active"];

  connect() {
    const initial = this.tabTargets.find((tab) => tab.dataset.tab === this.initialTab) || this.tabTargets[0];
    if (initial) this.activate(initial.dataset.tab);
  }

  show(event) {
    event.preventDefault();
    this.activate(event.currentTarget.dataset.tab);
  }

  activate(key) {
    this.panelTargets.forEach((panel) => panel.classList.toggle("hidden", panel.dataset.tab !== key));
    this.tabTargets.forEach((tab) => {
      const isActive = tab.dataset.tab === key;
      tab.classList.toggle("border-indigo-500", isActive);
      tab.classList.toggle("text-indigo-600", isActive);
      tab.classList.toggle("border-transparent", !isActive);
      tab.classList.toggle("text-zinc-500", !isActive);
      tab.setAttribute("aria-selected", isActive);
    });
  }

  get initialTab() {
    return this.element.dataset.tabsInitial;
  }
}
